import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconSvgComponent } from '@roomex/rx-components';

@Component({
  selector: 'rx-applications-rail-link',
  standalone: true,
  imports: [CommonModule, IconSvgComponent],
  templateUrl: './rail-link.component.html',
  styleUrl: './rail-link.component.scss',
})
export class RailLinkComponent {
  @Input({ transform: (value: string) => (value ? value : 'https://www.business.thetrainline.com/') })
  railPlatforLink: string = '';
}
